/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlIntegrationEntitlementWarningV2 } from './ControlIntegrationEntitlementWarningV2';
import {
    ControlIntegrationEntitlementWarningV2FromJSON,
    ControlIntegrationEntitlementWarningV2FromJSONTyped,
    ControlIntegrationEntitlementWarningV2ToJSON,
} from './ControlIntegrationEntitlementWarningV2';

/**
 * 
 * @export
 * @interface ControlIntegrationEntitlementV2
 */
export interface ControlIntegrationEntitlementV2 {
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationEntitlementV2
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationEntitlementV2
     */
    dismissed: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationEntitlementV2
     */
    display: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationEntitlementV2
     */
    slug: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationEntitlementV2
     */
    value: boolean;
    /**
     * 
     * @type {ControlIntegrationEntitlementWarningV2}
     * @memberof ControlIntegrationEntitlementV2
     */
    warning?: ControlIntegrationEntitlementWarningV2;
}

/**
 * Check if a given object implements the ControlIntegrationEntitlementV2 interface.
 */
export function instanceOfControlIntegrationEntitlementV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dismissed" in value;
    isInstance = isInstance && "display" in value;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ControlIntegrationEntitlementV2FromJSON(json: any): ControlIntegrationEntitlementV2 {
    return ControlIntegrationEntitlementV2FromJSONTyped(json, false);
}

export function ControlIntegrationEntitlementV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIntegrationEntitlementV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'dismissed': json['dismissed'],
        'display': json['display'],
        'slug': json['slug'],
        'value': json['value'],
        'warning': !exists(json, 'warning') ? undefined : ControlIntegrationEntitlementWarningV2FromJSON(json['warning']),
    };
}

export function ControlIntegrationEntitlementV2ToJSON(value?: ControlIntegrationEntitlementV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'dismissed': value.dismissed,
        'display': value.display,
        'slug': value.slug,
        'value': value.value,
        'warning': ControlIntegrationEntitlementWarningV2ToJSON(value.warning),
    };
}

